import { TelephoneNumber } from './telephone-number';

export class Employer {
    constructor(
        public RentalEmployerKey: number = 0,
        public EmployerName: string = '',
        public RentalIndustryKey: number = null,
        public Occupation: string = '',
        public StartDate: Date = null,
        public EndDate: Date = null,
        public Phone: string = '',
        public PhoneNumber: TelephoneNumber = null,
        public MonthlyPay: number = null,
        public SupervisorName: string = '',
        public SupervisorPhone: string = '',
        public SupervisorPhoneNumber: TelephoneNumber = null,
        public Address: string = '',
        public FileKey: number = null,
        public IsCurrnet: boolean = false,
        public EmploymentStatus: string = '',
        public IncomeProof: Document = null
    ) { }
}
